// Workspace constants for multi-brand support

// Special workspace ID for "All Brands" view
export const WORKSPACE_ALL = 'ALL_BRANDS';

// Workspace filter types
export const WORKSPACE_FILTERS = {
  ALL: 'ALL_BRANDS',        // Show everything across all workspaces
  CURRENT: 'current',        // Show current workspace only
  SPECIFIC: (id) => id       // Show specific workspace by ID
};

// Helper to check if in "All Brands" view
export const isAllBrandsView = (workspaceId) => {
  return workspaceId === WORKSPACE_ALL;
};

// Helper to get workspace filter for queries
export const getWorkspaceFilter = (workspaceId) => {
  if (isAllBrandsView(workspaceId)) {
    return null; // null means no filter (show all)
  }
  return workspaceId;
};

// Default workspace values
export const DEFAULT_WORKSPACE_COLORS = {
  primary: '#9333ea',
  secondary: '#ec4899'
};

// Workspace limits (for future use)
export const WORKSPACE_LIMITS = {
  FREE_TIER: 3,           // Free users can have 3 workspaces
  PRO_TIER: null          // Pro users have unlimited workspaces
};
